import PropTypes from 'prop-types';
import React from 'react';
import {BADGE_COLORS, BILLING_SUBSCRIPTION_PLAN_INTERVAL, ROLES} from '../../../common/constants';
import Badge from '../../../common/components/Badge';

const DisplayBillingPlan = ({plan}) => {
  if (plan.forRole === ROLES.MERCHANT) {
    if (plan.interval === BILLING_SUBSCRIPTION_PLAN_INTERVAL.MONTH) {
      return <Badge color={BADGE_COLORS.ORANGE}>{plan.nickname}</Badge>;
    } else {
      return <Badge color={BADGE_COLORS.BLUE}>{plan.nickname}</Badge>;
    }
  } else {
    if (plan.interval === BILLING_SUBSCRIPTION_PLAN_INTERVAL.MONTH) {
      return <Badge color={BADGE_COLORS.GREY}>{plan.nickname}</Badge>;
    } else {
      return <Badge color={BADGE_COLORS.RED}>{plan.nickname}</Badge>;
    }
  }
};

DisplayBillingPlan.propTypes = {
  plan: PropTypes.shape({
    nickname: PropTypes.string.isRequired,
  }).isRequired,
};

export default (DisplayBillingPlan);
